import { Show, createSignal } from "solid-js";
import Text from "./Text";
import InstallAppButton from "./InstallAppButton";
import { useTranslation } from "../hooks/useTranslation";
import { installAvailable } from "../services/pwa";
import styles from "./InstallAppBanner.module.css";

const DISMISS_KEY = "vektor_pwa_install_dismissed";

function readDismissed(): boolean {
  try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
}

export default function InstallAppBanner() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = createSignal(readDismissed());

  function dismiss() {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* private mode */ }
    setDismissed(true);
  }

  return (
    <Show when={installAvailable() && !dismissed()}>
      <div class={styles.banner}>
        <i class={`fa-solid fa-mobile-screen-button ${styles.icon}`} />
        <div class={styles.text}>
          <span class={styles.title}><Text val="INSTALL_BANNER_TITLE" /></span>
          <span class={styles.subtitle}><Text val="INSTALL_BANNER_TEXT" /></span>
        </div>
        <div class={styles.actions}>
          <InstallAppButton class="btn btn-primary btn-sm" />
          <button class="btn btn-icon" title={t("INSTALL_BANNER_DISMISS")} onClick={dismiss}>
            <i class="fa-solid fa-xmark" />
          </button>
        </div>
      </div>
    </Show>
  );
}
